import { gql } from "@apollo/client"

import { useMutation, InjectedOptions } from "@oysterhr/core"
import { InvoiceFields } from "../../../fragments"
import { CreateInvoiceInput, CreateInvoicePayload } from "@oysterhr/schema"

export const MUTATION = gql`
  mutation CreateInvoice(
    $companyId: ID!
    $signedDocumentId: String!
    $signedSupportingDocumentId: String
    $referenceCode: String!
    $invoiceDate: ISO8601Date!
    $dueDate: ISO8601Date!
    $amount: Float!
    $amountCurrencyCode: String!
    $notes: String
    $kind: InvoiceKind!
  ) {
    createInvoice(
      input: {
        companyId: $companyId
        signedDocumentId: $signedDocumentId
        signedSupportingDocumentId: $signedSupportingDocumentId
        referenceCode: $referenceCode
        invoiceDate: $invoiceDate
        dueDate: $dueDate
        amount: $amount
        amountCurrencyCode: $amountCurrencyCode
        notes: $notes
        kind: $kind
      }
    ) {
      invoice {
        ...InvoiceFields
      }
      errors
    }
  }

  ${InvoiceFields}
`

export const useCreateInvoice = (
  options?: InjectedOptions<CreateInvoicePayload, CreateInvoiceInput>,
) => useMutation<CreateInvoicePayload, CreateInvoiceInput>(MUTATION, options)
